import React from "react";
import './skills.css'
import UIDesign from '../../assets/webdev.png';
import WebDesign from '../../assets/blockchain.png';
import AppDesign from '../../assets/machine-learning.png';
import CloudDesign from '../../assets/cloud-server.png'

const Skills = () => {
    return (
        <section id='skills'>
            <span className="skillTitle">My Interests</span>
            <div className="skillBars">

            <div className="skillBar">
                    <img src={CloudDesign} alt="Cloud Computing" className="skillBarImg" />
                    <div className="skillBarText">
                        <h2>Cloud Computing</h2>
                        <p>I am learning Cloud Computing with AWS from basics in my free time. I am interested in learning how Cloud computing is effective for real-world projects.</p>
                    </div>
                </div>

                <div className="skillBar">
                    <img src={UIDesign} alt="Web Development" className="skillBarImg" />
                    <div className="skillBarText">
                        <h2>Web development</h2>
                        <p>Having a good flow, working with Angular and React applications. Worked with a MEAN stack application and got good experience with frontend web development</p>
                    </div>
                </div>

                <div className="skillBar">
                    <img src={WebDesign} alt="Blockchain" className="skillBarImg" />
                    <div className="skillBarText">
                        <h2>Blockchain</h2>
                        <p>Took a Blockchain specialization course out of pure interest in my college. I have learned the basic Blockchain concepts and currently developing my Web 2.0 skills to dive into Web 3.0 development in the future.</p>
                    </div>
                </div>

                <div className="skillBar">
                    <img src={AppDesign} alt="Machine learning" className="skillBarImg" />
                    <div className="skillBarText">
                        <h2>Machine learning</h2>
                        <p>Worked with a supervised machine learning project and a deep learning application for my final-year project. I found it pretty interesting and looking forward to do some side projects in this domain. </p>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default Skills